export default __webpack_public_path__ + "static/media/mp2_case_law_poster.21a52382.pdf";